

export function parseJSON(response) {
  return response.json();
}


export function checkStatus(response) {
  if(response.status >= 200 && response.status < 500) {
    return response;
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}